import type {Key} from 'swr';

type ProviderOverviewKeyParams = {
	country?: string;
	dateFrom?: string;
	dateTo?: string;
};

export const PROVIDER_OVERVIEW_KEYS = {
	topArtists: ({country}: ProviderOverviewKeyParams): Key | null =>
		country ? (['provider-overview', 'top-artists', country] as const) : null,

	topTracks: ({country}: ProviderOverviewKeyParams): Key | null =>
		country ? (['provider-overview', 'top-tracks', country] as const) : null,

	trendingArtists: ({country}: ProviderOverviewKeyParams): Key | null =>
		country
			? (['provider-overview', 'trending-artists', country] as const)
			: null,

	trendingTracks: ({country}: ProviderOverviewKeyParams): Key | null =>
		country
			? (['provider-overview', 'trending-tracks', country] as const)
			: null,

	streamingContexts: ({country}: ProviderOverviewKeyParams): Key | null =>
		country
			? (['provider-overview', 'streaming-contexts', country] as const)
			: null,

	timeseries: ({
		country,
		dateFrom,
		dateTo,
	}: ProviderOverviewKeyParams): Key | null =>
		country && dateFrom && dateTo
			? ([
					'provider-overview',
					'timeseries',
					country,
					dateFrom,
					dateTo,
				] as const)
			: null,
};
